import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, createTextVNode as _createTextVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79a3a1ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mt-3 mb-4" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-lg-10" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-items-end"
}
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { class: "mb-1" }
const _hoisted_7 = {
  key: 0,
  class: "lead text-preline"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 0,
  alt: "",
  class: "ml-auto",
  height: "144",
  width: "150"
}
const _hoisted_10 = { class: "text-center pt-1" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "d-flex flex-column align-items-center p-3" }
const _hoisted_13 = { class: "font-weight-bold lead text-primary" }
const _hoisted_14 = { class: "mb-0 lead" }
const _hoisted_15 = {
  key: 0,
  class: "mt-2 mb-0 font-weight-normal"
}
const _hoisted_16 = ["href"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "my-2" }
const _hoisted_19 = { class: "col d-flex flex-column align-items-center p-3" }
const _hoisted_20 = { class: "font-weight-bold lead text-primary" }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { class: "my-2" }
const _hoisted_23 = { class: "col d-flex flex-column align-items-center p-3" }
const _hoisted_24 = { class: "font-weight-bold lead text-primary" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_27 = { class: "category-breadcrumbs" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "mb-0 text-bold mr-1" }
const _hoisted_33 = { class: "mr-2" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "#000",
  height: "30",
  width: "34"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-support-avatar" })
], -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_37 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { key: 2 }
const _hoisted_41 = { key: 3 }
const _hoisted_42 = { key: 4 }
const _hoisted_43 = { class: "d-flex flex-column align-items-center p-1 w-100" }
const _hoisted_44 = { class: "font-weight-bold" }
const _hoisted_45 = { key: 5 }
const _hoisted_46 = {
  key: 1,
  class: "p-inputgroup"
}
const _hoisted_47 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_48 = { class: "d-flex align-items-center" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  height: "30",
  width: "30"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-cadac" })
], -1))
const _hoisted_50 = { class: "mb-0 text-bold" }
const _hoisted_51 = {
  key: 2,
  class: "d-flex align-items-center"
}
const _hoisted_52 = { class: "d-flex flex-column align-items-center p-2 border" }
const _hoisted_53 = { class: "font-weight-bold" }
const _hoisted_54 = {
  key: 6,
  class: "mb-3"
}
const _hoisted_55 = { class: "d-flex align-items-center" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle text-primary message-icon mr-2" }, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_58 = { key: 1 }
const _hoisted_59 = {
  key: 1,
  id: "`recaptcha-help`",
  class: "p-error"
}
const _hoisted_60 = {
  key: 2,
  class: "p-2"
}
const _hoisted_61 = ["innerHTML"]
const _hoisted_62 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_Message = _resolveComponent("Message")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_LinkButton = _resolveComponent("LinkButton")!
  const _component_AskAQuestionPersonalForm = _resolveComponent("AskAQuestionPersonalForm")!
  const _component_AskAQuestionSupportTicketForm = _resolveComponent("AskAQuestionSupportTicketForm")!
  const _component_AskAQuestionMessageForm = _resolveComponent("AskAQuestionMessageForm")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_lazy = _resolveDirective("lazy")!
  const _directive_badge = _resolveDirective("badge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "breadcrumbs", {}, undefined, true),
        (_ctx.activeStep < 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.vm.pageTitle), 1),
                (_ctx.vm.pageIntro)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.vm.pageIntro), 1))
                  : _createCommentVNode("", true),
                (!_ctx.layoutStore.isAuthenticated)
                  ? (_openBlock(), _createBlock(_component_Message, {
                      key: 1,
                      class: "p-1",
                      closable: false,
                      severity: "custom"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_i18n_t, { keypath: "support.message.loginForFasterAssistance" }, {
                          loginLink: _withCtx(() => [
                            _createElementVNode("a", { href: _ctx.loginPageUrl }, _toDisplayString(_ctx.$t("common.login")), 9, _hoisted_8)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              (!_ctx.isSmallScreen)
                ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_9, null, 512)), [
                    [_directive_lazy, '/Static/images/support.png']
                  ])
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_Card, null, _createSlots({
          content: _withCtx(() => [
            (_ctx.activeStep === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_SelectButton, {
                    modelValue: _ctx.selectedMainCategory,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMainCategory) = $event)),
                    class: "row m-0",
                    "data-key": "id",
                    options: _ctx.filteredMainCategories,
                    onChange: _ctx.updateQueryParams
                  }, {
                    option: _withCtx((slotProps) => [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["d-flex flex-column align-items-center", {
												'p-disabled':
												!_ctx.layoutStore.isAuthenticated &&
												_ctx.isSupportCategory(slotProps.option.categoryType),
											}])
                        }, [
                          _createVNode(_component_Avatar, {
                            class: "mb-2",
                            image: slotProps.option.icon,
                            shape: "square",
                            size: "large"
                          }, null, 8, ["image"]),
                          _createElementVNode("p", _hoisted_13, _toDisplayString(slotProps.option.title), 1),
                          _createElementVNode("p", _hoisted_14, _toDisplayString(slotProps.option.subtitle), 1)
                        ], 2),
                        (
												!_ctx.layoutStore.isAuthenticated &&
												_ctx.isSupportCategory(slotProps.option.categoryType)
											)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                              _createVNode(_component_i18n_t, { keypath: "support.message.loginForSupport" }, {
                                loginLink: _withCtx(() => [
                                  _createElementVNode("a", { href: _ctx.loginPageUrl }, _toDisplayString(_ctx.$t("common.login")), 9, _hoisted_16)
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "onChange"]),
                  (_ctx.otherMainCategory)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "my-2 p-0 p-button-text p-button-secondary p-button-link",
                        label: _ctx.otherMainCategory?.title,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedMainCategory = _ctx.otherMainCategory))
                      }, null, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedMainCategory)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.selectedMainCategory?.subCategoriesTitle), 1),
                        _withDirectives(_createVNode(_component_SelectButton, {
                          modelValue: _ctx.selectedSubCategory,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedSubCategory) = $event)),
                          class: "row m-0",
                          "data-key": "id",
                          options: _ctx.availableSubCategories,
                          onChange: _ctx.updateQueryParams
                        }, {
                          option: _withCtx((slotProps) => [
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode(_component_Avatar, {
                                class: "mb-2",
                                image: slotProps.option.icon,
                                shape: "square"
                              }, null, 8, ["image"]),
                              _createElementVNode("p", _hoisted_20, _toDisplayString(slotProps.option.title), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "onChange"]), [
                          [_vShow, _ctx.availableSubCategories?.length > 0]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedSubCategory)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("h3", _hoisted_22, _toDisplayString(_ctx.selectedSubCategory?.subCategoriesTitle), 1),
                        (_ctx.availableSubSubCategories?.length > 0)
                          ? (_openBlock(), _createBlock(_component_SelectButton, {
                              key: 0,
                              modelValue: _ctx.selectedSubSubCategory,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedSubSubCategory) = $event)),
                              class: "row m-0",
                              "data-key": "id",
                              options: _ctx.availableSubSubCategories,
                              onChange: _ctx.updateQueryParams
                            }, {
                              option: _withCtx((slotProps) => [
                                _createElementVNode("div", _hoisted_23, [
                                  _createVNode(_component_Avatar, {
                                    class: "mb-2",
                                    image: slotProps.option.icon,
                                    shape: "square"
                                  }, null, 8, ["image"]),
                                  _createElementVNode("p", _hoisted_24, _toDisplayString(slotProps.option.title), 1)
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "options", "onChange"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_ctx.activeStep === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("p", _hoisted_27, [
                        (_ctx.selectedMainCategory)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.selectedMainCategory.title), 1))
                          : _createCommentVNode("", true),
                        (_ctx.selectedSubCategory)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.selectedSubCategory.title), 1))
                          : _createCommentVNode("", true),
                        (_ctx.selectedSubSubCategory)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.selectedSubSubCategory.title), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.hasSelectedSupportCategory)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("support.amountOfTickets")), 1),
                            _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_33, _hoisted_35)), [
                              [
                                _directive_badge,
                                _ctx.vm.availableAmountOfSupportTickets,
                                void 0,
                                { secondary: true }
                              ]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_36,
                    (_ctx.hasSelectedSupportCategory)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          (_ctx.hasSupportProducts && _ctx.hasTickets)
                            ? (_openBlock(), _createElementBlock("h3", _hoisted_38, _toDisplayString(_ctx.vm.ticketsAndSubscriptionsTitle || _ctx.vm.ticketsAndSubscriptionsSubTitle), 1))
                            : (_ctx.hasSupportProducts && !_ctx.hasTickets)
                              ? (_openBlock(), _createElementBlock("h3", _hoisted_39, _toDisplayString(_ctx.vm.noTicketsButSubscriptionsTitle || _ctx.vm.noTicketsButSubscriptionsSubTitle), 1))
                              : (!_ctx.hasSupportProducts && _ctx.hasTickets)
                                ? (_openBlock(), _createElementBlock("h3", _hoisted_40, _toDisplayString(_ctx.vm.noSubscriptionsButTicketsTitle || _ctx.vm.noSubscriptionsButTicketsSubTitle), 1))
                                : (!_ctx.hasSupportProducts && !_ctx.hasTickets)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_41, _toDisplayString(_ctx.vm.noSubscriptionsAndNoTicketsSubtitle), 1))
                                  : _createCommentVNode("", true),
                          (_ctx.hasSupportProducts)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                _createVNode(_component_SelectButton, {
                                  modelValue: _ctx.selectedSupportProduct,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedSupportProduct) = $event)),
                                  class: "p-select-button-grid",
                                  "data-key": "sku",
                                  options: _ctx.vm.supportContractSupportAssets,
                                  onChange: _ctx.onSupportProductSelected
                                }, {
                                  option: _withCtx((slotProps) => [
                                    _createElementVNode("div", _hoisted_43, [
                                      _createVNode(_component_Avatar, {
                                        class: "mb-1",
                                        image: slotProps.option.icon,
                                        shape: "square"
                                      }, null, 8, ["image"]),
                                      _createElementVNode("p", _hoisted_44, _toDisplayString(slotProps.option.title), 1)
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "options", "onChange"])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.hasTickets)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                (_ctx.hasSupportProducts)
                                  ? (_openBlock(), _createBlock(_component_Divider, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("common.or")), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createElementVNode("h3", null, _toDisplayString(_ctx.vm.ticketsAndSubscriptionsOtherSoftwareTitle), 1),
                                (!_ctx.hasSelectedSupportTicketProduct)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                      _createVNode(_component_AutoComplete, {
                                        modelValue: _ctx.selectedSupportTicketProduct,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedSupportTicketProduct) = $event)),
                                        "force-selection": "",
                                        "min-length": 2,
                                        multiple: false,
                                        "option-label": "title",
                                        placeholder: _ctx.$t('myCadac.supportOverview.autocomplete.placeholder'),
                                        suggestions: _ctx.searchProductResults,
                                        onComplete: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSearchSoftware($event))),
                                        onItemSelect: _ctx.onSupportTicketProductSelected
                                      }, {
                                        item: _withCtx((slotProps) => [
                                          _createElementVNode("div", _hoisted_47, [
                                            _createElementVNode("div", _hoisted_48, [
                                              (slotProps.item.icon)
                                                ? (_openBlock(), _createBlock(_component_Avatar, {
                                                    key: 0,
                                                    alt: "product-icon",
                                                    class: "mr-1 bg-transparent",
                                                    image: slotProps.item.icon,
                                                    shape: "square"
                                                  }, null, 8, ["image"]))
                                                : (_openBlock(), _createBlock(_component_Avatar, {
                                                    key: 1,
                                                    alt: "product-icon",
                                                    class: "mr-1 bg-transparent",
                                                    shape: "square"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_49
                                                    ]),
                                                    _: 1
                                                  })),
                                              _createElementVNode("p", _hoisted_50, _toDisplayString(slotProps.item.title), 1)
                                            ])
                                          ])
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "placeholder", "suggestions", "onItemSelect"]),
                                      _createVNode(_component_Button, {
                                        class: "p-button-primary",
                                        icon: "pi pi-search"
                                      })
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                      _createElementVNode("div", _hoisted_52, [
                                        _createVNode(_component_Avatar, {
                                          class: "mb-1",
                                          image: _ctx.selectedSupportTicketProduct.icon,
                                          shape: "square"
                                        }, null, 8, ["image"]),
                                        _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.selectedSupportTicketProduct.title), 1),
                                        _createVNode(_component_Button, {
                                          class: "p-button-danger p-button-text",
                                          icon: "pi pi-times",
                                          title: _ctx.$t('common.remove'),
                                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedSupportTicketProduct = null))
                                        }, null, 8, ["title"])
                                      ])
                                    ])),
                                (_ctx.hasSelectedSupportTicketProduct)
                                  ? (_openBlock(), _createBlock(_component_Message, {
                                      key: 3,
                                      closable: false,
                                      severity: "warn"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("support.message.ticketProductWarning")), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.hasNoSearchResults)
                                  ? (_openBlock(), _createBlock(_component_Message, {
                                      key: 4,
                                      closable: false,
                                      severity: "warn"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("myCadac.supportOverview.autocomplete.msgNoResults", {
												query: _ctx.searchQuery,
											})), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]))
                            : (!_ctx.hasSupportProducts && !_ctx.hasTickets)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                  _createVNode(_component_Message, {
                                    class: "message-with-button my-3",
                                    closable: false,
                                    severity: "custom"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_55, [
                                        _hoisted_56,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.vm.ticketsCtaTitle), 1)
                                      ]),
                                      (_ctx.vm.subscriptionsLinkItem)
                                        ? (_openBlock(), _createBlock(_component_LinkButton, {
                                            key: 0,
                                            class: "p-button-success p-button-arrow m-1",
                                            label: _ctx.vm.subscriptionsLinkItem.text,
                                            target: _ctx.vm.subscriptionsLinkItem.target,
                                            title: _ctx.vm.subscriptionsLinkItem.title,
                                            url: _ctx.vm.subscriptionsLinkItem.url
                                          }, null, 8, ["label", "target", "title", "url"]))
                                        : _createCommentVNode("", true),
                                      (_ctx.vm.ticketsLinkItem)
                                        ? (_openBlock(), _createBlock(_component_LinkButton, {
                                            key: 1,
                                            class: "p-button-success p-button-arrow m-1",
                                            label: _ctx.vm.ticketsLinkItem.text,
                                            target: _ctx.vm.ticketsLinkItem.target,
                                            title: _ctx.vm.ticketsLinkItem.title,
                                            url: _ctx.vm.ticketsLinkItem.url
                                          }, null, 8, ["label", "target", "title", "url"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true),
                          _hoisted_57
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.showForms)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                          _createVNode(_component_AskAQuestionPersonalForm, {
                            modelValue: _ctx.v$,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.v$) = $event)),
                            ref: "personalForm",
                            submitted: _ctx.submitted,
                            onPhoneObjectValidationChange: _ctx.onPhoneObjectValidChanged
                          }, null, 8, ["modelValue", "submitted", "onPhoneObjectValidationChange"]),
                          (_ctx.showSupportTicketForm)
                            ? (_openBlock(), _createBlock(_component_AskAQuestionSupportTicketForm, {
                                key: 0,
                                modelValue: _ctx.v$,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.v$) = $event)),
                                submitted: _ctx.submitted
                              }, null, 8, ["modelValue", "submitted"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_AskAQuestionMessageForm, {
                            modelValue: _ctx.v$,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.v$) = $event)),
                            "is-support-question": _ctx.hasSelectedSupportCategory,
                            submitted: _ctx.submitted
                          }, null, 8, ["modelValue", "is-support-question", "submitted"]),
                          (_ctx.submitted && _ctx.recaptchaValid === false)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_59, _toDisplayString(_ctx.$t("validations.recaptcha")), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_ctx.activeStep === 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                      _createElementVNode("p", {
                        class: "lead",
                        innerHTML: _ctx.vm.requestSuccessMessage
                      }, null, 8, _hoisted_61),
                      (_ctx.vm.requestSuccessCtaLinkItem)
                        ? (_openBlock(), _createBlock(_component_LinkButton, {
                            key: 0,
                            label: _ctx.vm.requestSuccessCtaLinkItem.text,
                            target: _ctx.vm.requestSuccessCtaLinkItem.target,
                            title: _ctx.vm.requestSuccessCtaLinkItem.title,
                            url: _ctx.vm.requestSuccessCtaLinkItem.url
                          }, null, 8, ["label", "target", "title", "url"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_62, [
              (_ctx.activeStep === 2)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "p-button-secondary p-button-outlined px-3 mb-1 mr-1",
                    label: _ctx.$t(`common.previous`),
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.activeStep = 1))
                  }, null, 8, ["label"]))
                : _createCommentVNode("", true),
              (_ctx.activeStep < 3)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    class: "p-button-success p-button-arrow p-button-raised mb-1",
                    disabled: _ctx.activeStep === 2 ? (!_ctx.showForms || !_ctx.isFormInputsValid || _ctx.submitted) : !_ctx.canGoToNextStep,
                    loading: _ctx.isLoading,
                    label: _ctx.activeStep > 1 ? _ctx.$t(`common.send`) : _ctx.$t(`common.nextStep`),
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.goToNextStep()))
                  }, null, 8, ["disabled", "loading", "label"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, [
          (_ctx.activeStep < 3)
            ? {
                name: "header",
                fn: _withCtx(() => [
                  _createElementVNode("h6", _hoisted_10, _toDisplayString(_ctx.$t("common.stepXOfY", [_ctx.activeStep, 2])), 1),
                  _createVNode(_component_ProgressBar, {
                    class: "mx-2",
                    "show-value": false,
                    style: {"height":"1rem"},
                    value: _ctx.activeStep * 50
                  }, null, 8, ["value"])
                ]),
                key: "0"
              }
            : undefined
        ]), 1024)
      ])
    ])
  ]))
}